import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const internetConnectionSlice = createSlice({
  name: 'internetConnection',
  initialState: true,
  reducers: {
    setStatus: (state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setStatus } = internetConnectionSlice.actions;
export default internetConnectionSlice.reducer;
